import { AppEtape } from "src/commun/composants/formNavigation/AppEtapes";
import { UseAppTextReturn } from "src/commun/composants/AppText";
import { UserToFinalize } from "src/domain/UserToFinalize";

export enum FinalisationEtapes {
  Mail = "Mail",
  Telephone = "Telephone",
  InfoPerso = "InformationsPersonnelles",
  Finalisation = "Finalisation",
}

export const getInitialListeEtapes = (appText: UseAppTextReturn, userToFinalize: UserToFinalize): AppEtape[] => {
  // Création de toutes les étapes
  return [
    {
      id: FinalisationEtapes.Mail,
      nom: appText.t("migration.step.1.label"),
      etat: "NA",
      selectionne: true,
      data: {
        email: userToFinalize.emailAddress
      },
    },
    {
      id: FinalisationEtapes.Telephone,
      nom: appText.t("migration.step.2.label"),
      etat: "NA",
      selectionne: false,
      data: {},
    },
    {
      id: FinalisationEtapes.InfoPerso,
      nom: appText.t("migration.step.3.label"),
      etat: "NA",
      selectionne: false,
      data: {
        title: userToFinalize.title,
        lastName: userToFinalize.lastName,
        firstName: userToFinalize.firstName,
        telephonePro: userToFinalize.telephonePro,
      },
    },
    {
      id: FinalisationEtapes.Finalisation,
      nom: appText.t("migration.step.4.label"),
      etat: "NA",
      selectionne: false,
      data: undefined,
    },
  ];
};
